import "react-app-polyfill/ie9"; // For IE 9-11 support
import "react-app-polyfill/stable";
// import 'react-app-polyfill/ie11'; // For IE 11 support
import "./polyfill";
import React from "react";
import ReactDOM from "react-dom";
// import './index.css';
import "./App.scss";
import "font-awesome/css/font-awesome.min.css";

// import * as serviceWorker from './serviceWorker';
import boot from "./boot/index";

import { Provider } from "react-redux";
import configureStore from "./boot/configureStore";

const App = boot();
// import App from './App';
const { store } = configureStore();

ReactDOM.render(
  <Provider store={store}>
    <App />,
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.unregister();
